<nova-icon-registry />
<div class="app-shell">
  <router-outlet />
</div>
